import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Radio, Icon, notification, Divider, Modal } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const OPCOES_CRITERIO = [
    {
        value: 1,
        label: "Muito Bom"
    },
    {
        value: 2,
        label: "Bom"
    },
    {
        value: 3,
        label: "Suficiente"
    },
    {
        value: 4,
        label: "Fraco"
    }
];

const CRITERIOS_PADRAO = [
    {
        id: 1,
        descricao: "Interesse demonstrado pela matéria"
    },
    {
        id: 2,
        descricao: "Participação / Aplicação"
    },
    {
        id: 3,
        descricao: "Capacidade de apreensão de conhecimentos"
    },
    {
        id: 4,
        descricao: "Relacionamento interpessoal"
    },
    {
        id: 5,
        descricao: "Pontualidade"
    }
];

function DrawerAtribuirAvaliacaoFormando({
    cursoid,
    utilizadorid,
    visible,
    onClose,
    onCloseListar,
    classificacao_avaliacao_formandos = null,
    criterios = CRITERIOS_PADRAO
}) {
    const [iconLoading, setIconLoading] = useState(false);
    const [avaliacaoCriterios, setAvaliacaoCriterios] = useState({});
    const [avaliacaoQualitativa, setAvaliacaoQualitativa] = useState(null);
    const [classificacao, setClassificacao] = useState(null);
    const [observacoes, setObservacoes] = useState("");
    const [tipoAvaliacao, setTipoAvaliacao] = useState(null);
    const [originalData, setOriginalData] = useState(null);

    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [ficheiroNomeExportar, setFicheiroNomeExportar] = useState("");
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [visibleExportar, setVisibleExportar] = useState(false);

    useEffect(() => {
        if (!visible) {
            return;
        }

        try {
            let dados = [];

            if (classificacao_avaliacao_formandos) {
                dados = JSON.parse(classificacao_avaliacao_formandos);
            }

            if (!Array.isArray(dados)) {
                dados = [];
            }

            const item = dados[0];

            setAvaliacaoCriterios(item.criterios);

            const avaliacao = item.avaliacao;

            setAvaliacaoQualitativa(
                avaliacao.qualitativa !== undefined && avaliacao.qualitativa !== null ? Number(avaliacao.qualitativa) : null
            );

            setClassificacao(
                avaliacao.quantitativa !== undefined && avaliacao.quantitativa !== null && avaliacao.quantitativa !== ""
                    ? Number(avaliacao.quantitativa)
                    : null
            );

            if (avaliacao.qualitativa !== undefined && avaliacao.qualitativa !== null) {
                setTipoAvaliacao("qualitativa");
            } else if (avaliacao.quantitativa !== undefined && avaliacao.quantitativa !== null && avaliacao.quantitativa !== "") {
                setTipoAvaliacao("quantitativa");
            } else {
                setTipoAvaliacao(null);
            }

            setObservacoes(item.apreciacao_global);
        } catch (error) {
            setAvaliacaoCriterios({});
            setAvaliacaoQualitativa(null);
            setClassificacao(null);
            setObservacoes("");
        }
    }, [visible, classificacao_avaliacao_formandos]);

    useEffect(() => {
        if (!visible) {
            return;
        }

        if (!classificacao_avaliacao_formandos) {
            setOriginalData(null);
            return;
        }

        try {
            const dados =
                typeof classificacao_avaliacao_formandos === "string"
                    ? JSON.parse(classificacao_avaliacao_formandos)
                    : classificacao_avaliacao_formandos;

            if (Array.isArray(dados) && dados.length > 0) {
                setOriginalData(normalizarAvaliacao(dados[0]));
            } else {
                setOriginalData(null);
            }
        } catch (error) {
            openNotificationWithIcon("error", "Erro", "Não foi possível guardar!");

            setOriginalData(null);
        }
    }, [visible, classificacao_avaliacao_formandos]);

    const temAvaliacaoQualitativa = avaliacaoQualitativa !== null && avaliacaoQualitativa !== undefined;

    const temAvaliacaoQuantitativa =
        classificacao !== null && classificacao !== undefined && classificacao !== "" && classificacao >= 0 && classificacao <= 20;

    const temAvaliacao = temAvaliacaoQualitativa || temAvaliacaoQuantitativa;

    const criteriosTodosPreenchidos =
        criterios.length > 0 &&
        criterios.every(criterio => avaliacaoCriterios[criterio.id] !== undefined && avaliacaoCriterios[criterio.id] !== null);

    const podeGuardar = criteriosTodosPreenchidos && (temAvaliacaoQualitativa || temAvaliacaoQuantitativa);

    const handleTipoAvaliacaoChange = event => {
        const tipo = event.target.value;

        setTipoAvaliacao(tipo);

        if (tipo === "qualitativa") {
            setClassificacao(null);
        }
        if (tipo === "quantitativa") {
            setAvaliacaoQualitativa(null);
        }
    };

    const handleCriterioChange = (criterioId, valor) => {
        setAvaliacaoCriterios(prev => ({
            ...prev,
            [criterioId]: valor
        }));
    };

    const handleAvaliacaoQualitativaChange = event => {
        const valor = event.target.value;

        setAvaliacaoQualitativa(valor);
    };

    const handleClassificacaoChange = event => {
        setClassificacao(event.target.value);
    };

    const handleObservacoesChange = event => {
        setObservacoes(event.target.value);
    };

    const construirClassificacaoAvaliacaoFormandos = () => [
        {
            criterios: avaliacaoCriterios,
            avaliacao: {
                qualitativa: avaliacaoQualitativa,
                quantitativa: classificacao !== null && classificacao !== undefined && classificacao !== "" ? classificacao : null
            },
            apreciacao_global: observacoes
        }
    ];

    const dadosAtuais = JSON.stringify(construirClassificacaoAvaliacaoFormandos());

    const gerarDocumentoDisabled = originalData === null || dadosAtuais !== originalData || !criteriosTodosPreenchidos || !temAvaliacao;

    const normalizarAvaliacao = item => {
        return JSON.stringify([
            {
                criterios: item?.criterios || {},
                avaliacao: {
                    qualitativa:
                        item?.avaliacao?.qualitativa !== undefined && item?.avaliacao?.qualitativa !== null
                            ? Number(item.avaliacao.qualitativa)
                            : null,

                    quantitativa:
                        item?.avaliacao?.quantitativa !== undefined &&
                        item?.avaliacao?.quantitativa !== null &&
                        item?.avaliacao?.quantitativa !== ""
                            ? Number(item.avaliacao.quantitativa)
                            : null
                },
                apreciacao_global: item?.apreciacao_global || ""
            }
        ]);
    };

    const guardar = event => {
        if (iconLoading) {
            return;
        }

        setIconLoading(true);
        const item = new FormData();
        item.append("id_curso", cursoid);
        item.append("id_utilizador", utilizadorid);
        const classificacaoAvaliacaoFormandosAtual = construirClassificacaoAvaliacaoFormandos();
        item.append("classificacao_avaliacao", JSON.stringify(classificacaoAvaliacaoFormandosAtual));

        axios({
            method: "put",
            url: "/api/gestao-curso-resultados/atribuir-classificacao-final",
            data: item
        })
            .then(() => {
                setOriginalData(JSON.stringify(construirClassificacaoAvaliacaoFormandos()));

                setIconLoading(false);

                if (onCloseListar) onCloseListar();
                openNotificationWithIcon("success", "Sucesso", "Dados guardados com sucesso!");
            })
            .catch(() => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", "Não foi possível guardar!");
            });
    };

    const exportar = () => {
        setVisibleExportar(true);
        setBtnDescarregar(true);

        axios({
            method: "get",
            url: "/api/pdf/avaliacao-formando",
            params: {
                cursoId: cursoid,
                utilizadorId: utilizadorid
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data.ficheiro);
                setFicheiroNomeExportar(response.data.nome);
            })
            .catch(error => {
                setBtnDescarregar(false);

                if (error.response?.data === "SEM_REGISTOS") {
                    openNotificationWithIcon("warning", "Atenção", "Não existem registos para serem exportados!");
                } else {
                    openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                }

                setVisibleExportar(false);
            });
    };

    return (
        <>
            <Drawer
                className="drawer-from-outra-avaliacao"
                title="Avaliação do Formando"
                width={800}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
            >
                <div className="bloco-info">
                    <Form className="form-modulo" layout="vertical">
                        <Divider orientation="left">CRITÉRIOS</Divider>

                        {criterios.map((criterio, index) => (
                            <Form.Item label={`${index + 1} ${criterio.descricao}`} key={criterio.id}>
                                <Radio.Group
                                    value={avaliacaoCriterios[criterio.id]}
                                    onChange={e => handleCriterioChange(criterio.id, e.target.value)}
                                >
                                    {OPCOES_CRITERIO.map(opcao => (
                                        <Radio key={opcao.value} value={opcao.value}>
                                            {opcao.label}
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        ))}
                        <Divider orientation="left">AVALIAÇÃO</Divider>

                        {/* Escolha do tipo de avaliação */}
                        <Form.Item>
                            <Radio.Group value={tipoAvaliacao} onChange={handleTipoAvaliacaoChange}>
                                <Radio value="qualitativa">Qualitativa</Radio>

                                <Radio value="quantitativa">Quantitativa</Radio>
                            </Radio.Group>
                        </Form.Item>

                        {tipoAvaliacao === "qualitativa" && (
                            <Form.Item label="QUALITATIVA">
                                <Radio.Group value={avaliacaoQualitativa} onChange={handleAvaliacaoQualitativaChange}>
                                    <Radio value={1}>Aprovado</Radio>

                                    <Radio value={0}>Não aprovado</Radio>
                                </Radio.Group>
                            </Form.Item>
                        )}

                        {tipoAvaliacao === "quantitativa" && (
                            <Form.Item label="QUANTITATIVA (classificação de 0 a 20)">
                                <Input
                                    style={{ height: 40 }}
                                    value={classificacao}
                                    placeholder="0 - 20"
                                    onChange={handleClassificacaoChange}
                                />
                            </Form.Item>
                        )}

                        <Divider orientation="left">APRECIAÇÃO GLOBAL</Divider>

                        <Form.Item>
                            <TextArea
                                value={observacoes}
                                name="atribuir_observacoes"
                                onChange={handleObservacoesChange}
                                rows={4}
                                placeholder="Introduza a apreciação global do formando"
                                style={{
                                    resize: "vertical"
                                }}
                            />
                        </Form.Item>
                    </Form>
                </div>

                <div className="ant-drawer-footer">
                    <Link to="#" className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </Link>
                    <button
                        className="botao-principal"
                        style={{ marginRight: 20, display: "inline-block" }}
                        disabled={iconLoading || !podeGuardar}
                        onClick={() => guardar()}
                    >
                        {iconLoading ? <Icon type="loading" /> : null}
                        Guardar
                    </button>
                    <button
                        className="botao-principal"
                        style={{
                            marginRight: 20,
                            display: "inline-block"
                        }}
                        disabled={iconLoading || gerarDocumentoDisabled}
                        onClick={exportar}
                    >
                        {iconLoading ? <Icon type="loading" /> : null}
                        Gerar Documento
                    </button>
                </div>
            </Drawer>

            <Modal
                visible={visibleExportar}
                okText={
                    <a href={ficheiroExportar} download={ficheiroNomeExportar} onClick={() => setVisibleExportar(false)}>
                        Descarregar
                    </a>
                }
                onCancel={() => setVisibleExportar(false)}
                cancelText="Cancelar"
                okButtonProps={{ disabled: btnDescarregar }}
                maskClosable={false}
                className="exportar-csv"
            >
                <div className="exportar-csv-bloco">
                    {btnDescarregar ? (
                        <>
                            <p>
                                <Icon type="loading" />
                            </p>
                            <p className="texto">A gerar documento...</p>
                        </>
                    ) : (
                        <>
                            <p>
                                <Icon type="check-circle" style={{ color: "#84bd00" }} />
                            </p>
                            <p className="texto">Dados exportados com sucesso!</p>
                            <p className="ficheiro-extensao">.{ficheiroExportar.split(".")[ficheiroExportar.split(".").length - 1]}</p>
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
}

export default DrawerAtribuirAvaliacaoFormando;
